/*
 * @Author: seven.zhang 
 * @Date: 2019-02-26 14:47:52 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-03-19 15:17:59
 * 图表属性设置
 */
import Util from '@/utils/Util';
// let dpr = window.devicePixelRatio; //获取设备dpr
let dpr = Util.setDpr(); //获取设备dpr
const chartSet = {
    // 全装修市场监控系统-房企全装修交付覆盖率
    deliveryCoverSet:{//顺序为从外到里
        radius:[
            ['78%', '83%'],
            ['66%', '71%'],
            ['54%', '59%'],
            ['42%', '47%'],
            ['30%', '35%'],
        ],
        colorRange:[
            ['#0301FF','#8365FF'],
            ['#0099FF','#03E1FF'],
            ['#00FF81','#00FFD3'],
            ['#ff9a00','#ffc602'],
            ['#E00100','#F1923B'],
        ]
    },
    // 全装修市场监控系统-装修面积&装修套数（双折线图）
    areaCountChart(xData,seriesData){
        let series = [];
        let _unit = [];
        seriesData.forEach((item,index)=>{
            let list = {
                name: item.name,
                type: item.type,
                yAxisIndex:index,
                symbolSize:0,
                lineStyle: {
                    width:2*dpr,
                    color:item.lineColor
                },
                areaStyle: { //区域填充样式
                    normal: {
                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                        color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0,  color: item.color[0]}, 
                            { offset: 1,  color: item.color[1]}
                        ], false),
                    }
                },
                data: item.value
            }
            series.push(list)
            _unit.push(item.unit)
        })
        return {
            yAxisNum:2,
            color:['#00FFFF','#007DEA'],
            xAxis:{
                data: xData,
            },
            unit:_unit,
            grid: {
                left: '3.5%',
                right: '3%',
            },
            series:series
        }
    },
    // 全装修市场监控系统（tab 饼图）
    tabPieChart1(obj,type=1){//建筑面积占比 type=1 & 套数占比 type=2
        let color=[],
            title='',
            name='',
            data=[];
        switch(type){
            case 1:
                color=['#00FFFF','#4F748D']
                title=obj.iFullCnt+obj.areaHeader+'\n全装修'
                name="建筑面积占比"
                data=[
                    {value:obj.iFullCnt, name:'全装修'},
                    {value:obj.iRoughCnt, name:'毛坯'},
                ]
                break;
            case 2:
                color=['#0083FF','#4F758F']
                title=`{title|`+obj.iFullCount+obj.countHeader+`}`+'\n全装修'
                name="套数占比"
                data=[
                    {value:obj.iFullCount, name:'全装修'},
                    {value:obj.iRoughCount, name:'毛坯'},
                ]
                break;
        }
        return {
            hasCircle:true,
            color:color,
            title:[
                {
                    text: title,
                    textAlign:'center',
                    textStyle: {
                        fontSize: 14*dpr,
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        color: '#FFFFFF',
                        rich:{
                            title:{
                                fontSize:16*dpr,
                                color:color[0],
                            },
                        }
                    },
                    left:'48%',
                    top:'33%',

                },
            ],
            tooltip:{
                show:false
            },
            series:{
                name:name,
                data:data,
                startAngle: 108,
            }
        }
    },
    tabPieChart2(obj){//装修标准占比
        return {
            color:['#07CA99','#EF732E','#FFCC02','#02CCFF','#FF9273'],
            title:[
                {
                    text: '装修\n标准',
                    textAlign:'center',
                    textStyle: {
                        fontSize: 14*dpr,
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        color: '#FFFFFF'
                    },
                    left:'49%',
                    top:'35%',
                },
            ],
            series:{
                name:'装修标准占比',
                center: ['50%', '45%'],
                radius: ['35%', '50%'],
                // hoverAnimation: true,
                data:[
                    {value:obj.iFourThousandUp, name:'4000以上'},
                    {value:obj.iThreeThousandToFour, name:'3000-4000'},
                    {value:obj.iTwoThousandToThree, name:'2000-3000'},
                    {value:obj.iOneThousandToTwo, name:'1000-2000'},
                    {value:obj.iOneThousandBlow, name:'1000以下'},
                ]
            }
        }
    },
    tabPieChart4(obj){//项目类型占比
        return {
            color:['#07CA99','#EF732E','#FFCC02','#02CCFF','#FF9273'],
            title:[
                {
                    text: '项目\n类型',
                    textAlign:'center',
                    textStyle: {
                        fontSize: 14*dpr,
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        color: '#FFFFFF'
                    },
                    left:'51%',
                    top:'35%',
                },
            ],
            series:{
                name:'项目类型占比',
                center: ['53%', '45%'],
                radius: ['35%', '50%'],
                // hoverAnimation: true,
                data:obj,
                // [
                //     {value:obj.iFourThousandUp, name:'商业/办公'},
                //     {value:obj.iEconomical, name:'经济适用房'},
                //     {value:obj.iLimitPrice, name:'限价房'},
                //     {value:obj.iRelocation, name:'动迁安置房'},
                //     {value:obj.iSupport, name:'配套商品房'},
                //     {value:obj.iVilla, name:'别墅'},
                //     {value:obj.iNormal, name:'普通住宅'},
                // ]
                minAngle: 10,
                startAngle: 38,
            }
        }
    },
    // 尖角环形饼图
    tabDonutPieChart(obj,type=1){//建筑面积占比 type=1 & 套数占比 type=2
        let color=[],
            title='',
            name='',
            data=[];
        let itemStyle = (color)=>{
            return { 
                "borderColor":color,
                "borderWidth": 8*dpr
            }
        }
        switch(type){
            case 1:
                color=['#4F748D','#00FFFF']
                title=obj.iFullCnt+obj.areaHeader+'\n全装修'
                name="建筑面积占比"
                data=[
                    {value:obj.iRoughCnt, name:'毛坯',itemStyle:itemStyle(color[0]),label:{
                        normal: {
                            show: true,
                            formatter(param){
                                return [
                                        '{value|'+Util.keepPoint(param.percent,1)+'}{unit|%}',
                                        '{label|'+param.name+'}',
                                        ''
                                    ].join('\n')
                            },
                            position: 'outside',
                            fontSize: 12 * dpr,
                            rich: {
                                value: {
                                    fontSize: 18 * dpr,
                                    color: '#fff'
                                },
                                unit: {
                                    fontSize: 12 * dpr,
                                    color: '#fff'
                                },
                                label: {
                                    fontSize: 12 * dpr,
                                    color: '#fff'
                                }
                            }
                        },
                    },},
                    {value:obj.iFullCnt, name:'全装修',itemStyle:itemStyle(color[1])},
                ]
                break;
            case 2:
                color=['#4F758F','#0083FF']
                title=`{title|`+obj.iFullCount+obj.countHeader+`}`+'\n全装修'
                name="套数占比"
                data=[
                    {value:obj.iRoughCount, name:'毛坯',itemStyle:itemStyle(color[0]),label: {
                        normal: {
                            show: true,
                            formatter(param){
                                return [
                                        '{value|'+Util.keepPoint(param.percent,1)+'}{unit|%}',
                                        '{label|'+param.name+'}',
                                        ''
                                    ].join('\n')
                            },
                            position: 'outside',
                            fontSize: 12 * dpr,
                            rich: {
                                value: {
                                    fontSize: 18 * dpr,
                                    color: '#fff'
                                },
                                unit: {
                                    fontSize: 12 * dpr,
                                    color: '#fff'
                                },
                                label: {
                                    fontSize: 12 * dpr,
                                    color: '#fff'
                                }
                            }
                        },
                    },},
                    {value:obj.iFullCount, name:'全装修',itemStyle:itemStyle(color[1])},
                ]
                break;
        }
        return {
            hasCircle:true,
            color:color,
            title:[
                {
                    text: title,
                    textAlign:'center',
                    textStyle: {
                        fontSize: 14*dpr,
                        fontWeight: 'normal',
                        fontStyle: 'normal',
                        color: '#FFFFFF',
                        rich:{
                            title:{
                                fontSize:16*dpr,
                                color:color[1],
                            },
                        }
                    },
                    left:'48%',
                    top:'35%',

                },
            ],
            tooltip:{
                show:false
            },
            series:{
                name:name,
                data:data,
                // startAngle: 0,
                clockwise: false,
                radius: ['53%', '56%'],
                silent: true,
            }
        }
    },
    // 报告大屏页折柱图
    reportLineBarChart(obj){//成交价格、成交面积趋势(折柱图)
        let color = ['#00A4DF','#FFF100']
        let unit = [obj.barObj.unit,obj.lineObj.unit]
        return {
            color:color,
            yAxisNum:2,
            unit:unit,
            grid:{
                bottom:'5%',
                left:'5%',
                right:'4%',
            },
            tooltip: {
                formatter: function(param) {
                    // console.log(param,obj)
                    let title = `<span style="opacity:0">${param[0].marker}</span><span class="fs_12 c_fff">${param[0].name}</span>`
                    let data=[]
                    param.forEach((item,index)=>{
                        let marker =`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[index]};"></span>`
                        let list = marker+`<span class="fs_12 c_fff">${item.seriesName}</span>
                                                <span class="fs_16 fw_b c_fff">${Util.formatNum(item.value)}</span>
                                                <span class="fs_12 c_fff"">${unit[index]}</span>`
                        data.push(list)
                    })
                    
                    return data.join('<br />') + '<br />'+ title
                        
                },
            },
            xAxis:{
                // boundaryGap: true,
                axisLabel: { //坐标轴刻度标签的相关设置
                    textStyle: {
                        color: '#7F8FA4',
                        margin:15,
                        fontSize: 12*dpr,
                    },
                },
                data: obj.xAxisData,
            },
            yAxis:{
                splitLine: {
                    show: true,
                    lineStyle:{
                        color: '#C5D0DE',
                        opacity:0.3,
                        width: 1*dpr,
                    }
                },
            },
            series:[
                {
                    name: obj.barObj.name,
                    type: 'bar',
                    barWidth: 36*dpr,
                    itemStyle: { //区域填充样式
                        // color:'#00A4DF',
                        barBorderRadius: [4*dpr,4*dpr,0,0],
                        //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                        color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            { offset: 0, color: '#0787DC'},
                            { offset: 1, color: '#25D8FF'}
                        ])
                    },
                    data: obj.barObj.data
                },
                {
                    name: obj.lineObj.name,
                    type: 'line',
                    yAxisIndex:1,
                    lineStyle: {
                        normal:{
                            color:'#FFF100',
                            width:2*dpr,
                        }
                    },
                    symbolSize:0,
                    data: obj.lineObj.data
                },
            ]
        }
    },

    /**
     * 列表页——玫瑰饼图
     * @param {*} obj 
     * obj{
     *  title:''//标题
     *  data:[]//值
     * }
     */
    listPieCharts(obj){
        return {
            title:{
                text:obj.title,
                textStyle:{
                    color:'#1D2531',
                    align:'center',
                    fontSize:14*dpr,
                },
                textAlign:'center',
                left:'49%',
                top:'45%',
            },
            series:{
                name:obj.title,
                roseType : 'radius',//or area
                label: {
                    normal:{
                        show:true,
                        // formatter:[
                        //     '{value|{d}}{unit|%}',
                        //     '{label|{b}}',
                        //     ''
                        // ].join('\n'),
                        formatter(param){
                            return [
                                    '{value|'+Util.keepPoint(param.percent,1)+'}{unit|%}',
                                    '{label|'+param.name+'}',
                                    ''
                                ].join('\n')
                        },
                        position: 'top',
                        fontSize: 12*dpr,
                        rich: {
                            value: {
                                fontSize:20*dpr,
                            },
                            unit: {
                                fontSize:12*dpr,
                            },
                            label: {
                                fontSize:12*dpr,
                                color:'#7F8FA4'
                            }
                        }
                    },
                },
                data:obj.data,
                minAngle:18,
            }
        }
    },
    /**
     * 列表页——折柱图
     * @param {*} obj 
     * obj{
     *  title:''//标题
     *  xAxisData:[]
     *  series:[{ type:'', name:'', data:[], unit:''}]
     * }
     */
    listLineBarCharts(obj){
        let color=['#00A4DF','#FFCC02']
        let unit=[];
        let mySeries=[];
        let yAxis = []
        obj.series.forEach((item,index)=>{
            let list = {
                name: item.name+'('+item.unit+')',
                type: item.type,
                data: item.data
            }
            switch(item.type){
                case 'bar':
                    list={...list,...{
                        itemStyle: { 
                            barBorderRadius: [4*dpr,4*dpr,0,0],
                        },
                        barMaxWidth:36*dpr
                    }}
                    break;
                case 'line':
                    list={...list,...{
                        yAxisIndex:1,
                        lineStyle: {
                            normal:{
                                width:2*dpr,
                            }
                        },
                        symbolSize:0,
                    }}
                    break;
            }
            mySeries.push(list)
            unit.push(item.unit)

            // yAxis
            let y_max = Util.calMax([mySeries[index].data])
            let yAxisItem = {
                min: 0,
                max: y_max,// 计算最大值
                interval: Math.ceil(y_max / 5),// 平均分为5份
                splitLine: {
                    show: true,
                    lineStyle:{
                        color: '#C5D0DE',
                        opacity:0.1,
                        width: 1*dpr,
                    }
                },
            }
            yAxis.push(yAxisItem)
        })
        
        return {
            color:color,
            yAxisNum:2,
            unit:unit,
            title:{
                text:obj.title,
                textStyle:{
                    color:'#1D2531',
                    fontSize:14*dpr,
                },
                textAlign:'center',
                left:'50%',
                bottom:0,
            },
            tooltip: {
                formatter: function(param) {
                    // console.log(param)
                    let title = `<span class="fs_12 c_fff">${param[0].name}</span>`
                    let data=[]
                    param.forEach((item,index)=>{
                        let list = `<span class="fs_12 c_fff">
                                        ${obj.series[index].name}
                                        <span class="fs_18" style="color:${color[index]};font-weight:bold;">${Util.formatNum(item.value)}</span>
                                        ${unit?unit[index]:''}
                                    </span>`
                        data.push(list)
                    })
                    
                    return data.join('<br />') + '<br />'+ title
                        
                },
            },
            grid:{
                top:'20%',
                bottom:'20%',
                left:'7%',
                right:'7%',
                ...obj.grid
            },
            legend:{
                show:true,
                ...obj.legend
            },
            xAxis:{
                boundaryGap: true,
                axisLine:{
                    show:true,
                    lineStyle: {
                        color: '#E7E9ED'
                    },
                },
                axisLabel: { //坐标轴刻度标签的相关设置
                    textStyle: {
                        color: '#7F8FA4',
                        margin:15,
                        fontSize: 12*dpr,
                    },
                },
                data: obj.xAxisData,
            },
            yAxis:yAxis,
            series:mySeries
        }
    },
}
export default chartSet
